import React from 'react';
import IconChevronDown from '../../../../../../../components/icons/icon-chevron-down/icon-chevron-down';

import './custom-collapsible.scss';

interface CustomCollapsibleProps {
    title: React.ReactNode;
    rightContent?: React.ReactNode;
    children: React.ReactNode;
    isExpanded: boolean;
    onToggle?: () => void;
    level?: 'primary' | 'secondary' | 'tertiary';
}

const CustomCollapsible: React.FC<CustomCollapsibleProps> = ({ 
    title, 
    rightContent, 
    children, 
    isExpanded, 
    onToggle, 
    level = 'primary' 
}) => {
    const [expanded, setExpanded] = React.useState(isExpanded);
    
    const handleToggle = () => {
        setExpanded(!expanded);
        onToggle?.();
    };

    return (
        <div className={`custom-collapsible ${level} ${expanded ? 'expanded' : ''}`}>
            <div 
                className={`collapsible-header ${level} ${expanded ? 'expanded' : ''}`}
                onClick={handleToggle}
            >
                <div className="flex-between">
                    <div className="flex-1">
                        {title}
                    </div>
                    <div className="right-content-group">
                        {rightContent}
                        <div className={`chevron-icon ${expanded ? '' : 'collapsed'}`}>
                            <IconChevronDown color="var(--color-primary-1)" />
                        </div>
                    </div>
                </div>
            </div>
            {expanded && (
                <div className={`collapsible-content ${level} expanded`}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default CustomCollapsible;
